import React from 'react'
import clsx from 'clsx'
import { classToFComponent, type FCClassContext, ViewSlot } from 'cube-react'
import { type MessageStatus } from '@govbr-ds/core'
import { BrModal, type BrModalProps, BrMessage } from '@govbr-ds/react-components'
import { AlertScope } from '../main.scope'

import Sel from '@/shared/view/CssSelectors'

export type AlertProps = {
    scope: AlertScope
}

export class AlertViewClass implements FCClassContext<AlertProps> {
    scope!: AlertScope

    render({ scope }: AlertProps) {
        this.scope = scope

        const brModalProps: BrModalProps = { isOpen: true }
        brModalProps.title = scope.title
        brModalProps.minWidth = scope.minWidth
        brModalProps.minHeight = scope.minHeight
        brModalProps.height = scope.height
        brModalProps.width = scope.width
        brModalProps.keepOpenOnPrimaryAction = scope.keepOpenOnPrimaryAction
        brModalProps.keepOpenOnSecondaryAction = scope.keepOpenOnSecondaryAction
        brModalProps.focusOnPrimaryAction = scope.focusOnPrimaryAction
        brModalProps.focusOnSecondaryAction = scope.focusOnSecondaryAction
        brModalProps.primaryAction = scope.primaryAction
        brModalProps.secondaryAction = scope.secondaryAction
        brModalProps.onClose = this.scope.onClose

        let contentElm = scope.content ? <ViewSlot scope={scope.content} /> : this.messageRender(scope)

        return (
            <div className={clsx(Sel.placeHolder, Sel.primeiroBrCardNoShadow)}>
                <BrModal {...brModalProps}>{contentElm}</BrModal>
            </div>
        )
    }

    messageRender(scope: AlertScope) {
        const status: MessageStatus = scope.severity

        return (
            <div className={Sel.brModalBody}>
                <BrMessage status={status} category="message" closable={false} message={scope.message} />
            </div>
        )
    }
}

export default classToFComponent<AlertProps>(AlertViewClass)
